import Repository from '@/types/repositoryType';

export type Documentation = {
  IntroArtifactUUID: string;
  Content: string;
  LastRefreshed?: string;
  VectorDBUrl?: string;
  RepoName?: string;
  DocType?: DocType;
  IsMainDoc?: boolean;
  RepoUUID?: string;
  uuid?: string;
  doc_level?: DocLevel;
  // Repository fields are grafted on by useRepoDocs when a doc row matches a
  // repo. A doc whose repo is missing from the list carries none of them, so
  // they are optional: the previous required intersection only typechecked
  // because the repo list was `any[]`.
} & Partial<Repository>;

export enum DocType {
  TECH_DOCS = 'TECH_DOCS',
  TUTORIAL = 'TUTORIAL',
  VISUALIZE = 'VISUALIZE',
}

export enum DocLevel {
  SECTION = 'SECTION',
  SUBSECTION = 'SUBSECTION',
  OVERVIEW = 'OVERVIEW',
  V1 = 'v1',
}

export interface Document {
  artifactUUID: string;
  content: string;
  title: string;
}

export interface BlurredContentProps<T> {
  data: T;
  mockData: React.ReactNode;
  children: React.ReactNode;
}
